import { render, staticRenderFns } from "./CardsDialog.vue?vue&type=template&id=76851fba&scoped=true"
import script from "./CardsDialog.vue?vue&type=script&lang=js"
export * from "./CardsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76851fba",
  null
  
)

export default component.exports